import { AbstractDictionary } from "./AbstractDictionary";
export class DicIssuingAuthority extends AbstractDictionary {
  static NAME = "tsadv_DicIssuingAuthority";
}
export type DicIssuingAuthorityViewName =
  | "_base"
  | "_local"
  | "_minimal"
  | "dicIssuingAuthority.for.integration";
export type DicIssuingAuthorityView<
  V extends DicIssuingAuthorityViewName
> = V extends "_base"
  ? Pick<
      DicIssuingAuthority,
      | "id"
      | "langValue"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
    >
  : V extends "_local"
  ? Pick<
      DicIssuingAuthority,
      | "id"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
    >
  : V extends "_minimal"
  ? Pick<DicIssuingAuthority, "id" | "langValue">
  : V extends "dicIssuingAuthority.for.integration"
  ? Pick<
      DicIssuingAuthority,
      | "id"
      | "legacyId"
      | "organizationBin"
      | "integrationUserLogin"
      | "langValue1"
      | "description1"
      | "langValue2"
      | "description2"
      | "langValue3"
      | "description3"
      | "langValue4"
      | "description4"
      | "langValue5"
      | "description5"
      | "startDate"
      | "endDate"
      | "code"
      | "isSystemRecord"
      | "active"
      | "isDefault"
      | "order"
      | "company"
    >
  : never;
